import { getStarredChatsV2 } from './getStarredChatsV2';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';
import { ERequestTrigger } from '../../types/requestTrigger';

export const getStarredChatsListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestampStarred = chatList.isFirstLoad
    ? undefined
    : chatList.chats.length
      ? getLastTimeStamp(chatList.chats)
      : state.chatList.timestampStarred;

  const trigger = chatList.isFirstLoad ? ERequestTrigger.ChatListInitialLoad : ERequestTrigger.ChatListScroll;

  dispatch(getStarredChatsV2({ timestampStarred, trigger }));
};
